import {
  faCircleNotch,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IDistrict } from "../../../redux/slices/appSlice";
import useFetch, { API_BASE_URL } from "../../../utils/useFetch";
import { MapContainer, TileLayer } from "react-leaflet";
import { LatLng } from "leaflet";
import "leaflet/dist/leaflet.css";
import { useCallback } from "react";
import { useEffect } from "react";
import { RootState } from "../../../redux/store";
import { setUpdatedUserInfo } from "../../../redux/slices/userSlice";

const CompleteSignUp = () => {
  const { data: districts } = useFetch<IDistrict[]>("districts");
  const [name, setName] = useState("");
  const [district, setDistrict] = useState("0");
  const [address, setAddress] = useState("");
  const [isSendingData, setIsSendingData] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userData = useSelector((state: RootState) => state.user.userInfo);

  const center = useMemo(
    () => new LatLng(31.294992331159847, 48.641390331260936),
    []
  );
  const zoom = 15;

  const addAdrsFetch = async () => {
    console.log(position!.lat, position!.lng);
    const _formData = new FormData();
    _formData.append("region_id", district);
    _formData.append("address", address);
    _formData.append("lat", position.lat);
    _formData.append("lang", position.lng);
    _formData.append("code", userData.code);
    _formData.append("mobile", userData.mobile);
    setIsSendingData(true);
    const response = await fetch(API_BASE_URL + "addnewaddress", {
      method: "POST",
      body: _formData,
    });
    return response.text();
  };

  const fetchUpdateName = async () => {
    const _formData = new FormData();
    _formData.append("mobile", userData.mobile);
    _formData.append("code", userData.code);
    _formData.append("name", name);
    const response = await fetch(API_BASE_URL + "newupdatename", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  };

  const validateForm = () => {
    if (name.length < 5) {
      toast.error("نام خود را کامل وارد کنید");
      return;
    }
    if (district === "0") {
      toast.error("لطفا منطقه خود را انتخاب کنید");
      return;
    }
    if (!position) {
      toast.error("لطفا آدرس خود روی نقشه را انتخاب کنید");
      return;
    }
    if (address.length < 10) {
      toast.error("لطفا آدرس خود را کامل بنویسید");
      return;
    }
    return true;
  };
  const onFormSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      addAdrsFetch().then((response) => {
        if (response) {
          fetchUpdateName()
            .then((response) => {
              toast.success("ثبت نام شما با موفقیت تکمیل شد");
              dispatch(setUpdatedUserInfo(response.data));
              navigate("/");
            })
            .finally(() => {
              setIsSendingData(false);
            });
        } else {
          toast.error("Error XyxcpP");
        }
      });
    }
  };

  const [map, setMap] = useState<any>();
  const [position, setPosition] = useState<any>();
  const onMove = useCallback(() => {
    console.log(map.getCenter());
    setPosition(map.getCenter());
  }, [map]);
  useEffect(() => {
    if (map) {
      map.on("move", onMove);
    }
    return () => {
      if (map) {
        map.off("move", onMove);
      }
    };
  }, [map, onMove]);
  const displayMap = useMemo(
    () => (
      <MapContainer
        center={center}
        className='h-60 z-0'
        zoom={zoom}
        scrollWheelZoom={false}
        ref={setMap}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />
      </MapContainer>
    ),
    [center]
  );

  return (
    <>
      <div
        id='authentication-modal'
        aria-hidden='true'
        className=' w-full mx-auto p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] md:h-full'
      >
        <div className=' w-full h-full max-w-md md:h-auto mx-auto'>
          <div className=' bg-white rounded shadow'>
            <div className='px-6 py-6 lg:px-8'>
              <div className='mb-8 text-4xl font-bold text-center'>
                تکمیل ثبت نام
              </div>

              <form
                className={`space-y-6`}
                action='#'
                onSubmit={onFormSubmit}
              >
                <div>
                  <label
                    htmlFor='subcode'
                    className='block mb-2 text-sm font-medium flex'
                  >
                    <div className='flex-1'>نام و نام خانوادگی </div>
                  </label>
                  <input
                    type='text'
                    onChange={(e) => setName(e.target.value)}
                    name='name'
                    className='bg-gray-50 border border-gray-300  text-sm rounded focus:border-rose-500 outline-rose-700 block w-full p-2'
                    placeholder=''
                  />
                </div>

                <div
                  className='relative h-60'
                  style={{ overflow: "hidden" }}
                >
                  <div className='absolute inline-block inset-y-2/4 inset-x-2/4 z-50'>
                    <FontAwesomeIcon
                      className='text-xl text-rose-900'
                      icon={faMapMarkerAlt}
                    />
                  </div>
                  <div>{displayMap}</div>
                </div>

                <div>
                  <label
                    htmlFor='region'
                    className='block mb-2 text-sm font-medium'
                  >
                    منطقه
                  </label>
                  <select
                    onChange={(e) => setDistrict(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                  >
                    <option value={0}>انتخاب کنید...</option>
                    {districts?.map((district: IDistrict) => (
                      <option
                        key={district.id}
                        value={district.id}
                      >
                        {district.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div>
                  <label
                    htmlFor='address'
                    className='block mb-2 text-sm font-medium'
                  >
                    آدرس کامل
                  </label>
                  <input
                    type='text'
                    name='address'
                    onChange={(e) => setAddress(e.target.value)}
                    className='bg-gray-50 border border-gray-300  text-sm rounded outline-rose-700 block w-full p-2'
                  />
                </div>

                <div className='flex items-center'>
                  <button
                    type='submit'
                    disabled={isSendingData}
                    className='flex-1 w-full cursor-pointer text-white bg-rose-900 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800'
                  >
                    {isSendingData ? (
                      <FontAwesomeIcon
                        icon={faCircleNotch}
                        className='rotate-animation'
                      />
                    ) : (
                      "ثبت نام"
                    )}
                  </button>
                </div>

                <div className='text-sm font-medium text-gray-500'></div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteSignUp;
